module.exports = __webpack_public_path__ + "img/Girl_020019.342ead43.png";